import { Component } from '@angular/core';
import { IGenericCrudConfiguration } from 'src/app/libs/components/generic-crud/generic-crud.component';
import { TechnicalFeaturesGroups } from 'src/app/models';
import { MasterApiService } from 'src/app/services/master-api.service';
import { ProductsTechnicalFeaturesGroupsAddComponent } from './products-technical-features-groups-add/products-technical-features-groups-add.component';
import { ProductsTechnicalFeaturesGroupsEditComponent } from './products-technical-features-groups-edit/products-technical-features-groups-edit.component';

@Component({
    selector: 'app-products-technical-features-groups',
    templateUrl: './products-technical-features-groups.component.html',
    styleUrls: ['./products-technical-features-groups.component.css'],
    standalone: false
})
export class ProductsTechnicalFeaturesGroupsComponent {

  config?: IGenericCrudConfiguration<TechnicalFeaturesGroups>;

  constructor(private api: MasterApiService){

    this.config = {
      name: this.api.resources.product.technicalFeatureGroups.resourceName,
      resource: this.api.resources.product.technicalFeatureGroups,
      createComponent: ProductsTechnicalFeaturesGroupsAddComponent,
      editComponent: ProductsTechnicalFeaturesGroupsEditComponent,
      entityFields: {
        name: {isLink: true},
      },
      crudButtons: {
        canCreate: true,
        canEdit: true,
        canDelete: true,
        canCopy: false,
      }
      
    }
  }
}
